<template lang="pug">
  SspLayout(area="core")
    Loading(v-if="loadingInitialData") Loading product details and schemas
    .product-metadata(v-else)
      .form-group
        label Schema
        .input
          select.form-control(v-model="selectedSchemaId")
            option(:value="null") [none]
            option(v-for="schema in schemas" :value="schema.id") {{schema.name}}
      hr
      .schema-selected(v-if="selectedSchemaId")
        Loading(v-if="loadingSchema") Loading schema...
        .editor(v-else)
          MetadataEditor(:schema="schema" :metadata="metadata" :disabled="readOnly || saving" @update:data="updateMetadata")
      .alert.alert-warning(v-else)
        span Metadata schema not selected. Please select metadata schema.
      .text-right
        SspActionButton.save-button(@onClick="save()" :spinning="saving" :disabled="readOnly || initialState || !isValid") Save
        a.ml10.btn.btn-default(type="button" @click="$router.go(-1)") Cancel
</template>
<script>
import miniToastr from 'mini-toastr'
import MetadataEditor from '@/components/metadataeditor/MetadataEditor'
import Core from '@/service/apis/Core'
import Masterdata from '@/service/apis/Masterdata'

export default {
  data: () => ({
    product: null,
    selectedSchemaId: null,
    schemas: [],
    schema: {},
    metadata: {},
    readOnly: false,
    loadingInitialData: true,
    loadingSchema: false,
    saving: false,
    isValid: true
  }),
  created() {
    Promise.all([
      this.loadProduct(),
      this.loadSchemas()
    ])
      .then(() => {
        if (this.product.metadataSchemaId) {
          this.selectedSchemaId = this.product.metadataSchemaId
          return this.loadMetadata()
        }
      })
      .catch((e) => { this.$emit('error', e) })
      .then(() => {
        this.loadingInitialData = false
      })
  },
  watch: {
    selectedSchemaId() {
      this.metadata = {} // clear previous metadata fields...
      if (this.selectedSchemaId) {
        this.loadingSchema = true
        const schemaName = this.findSchemaName(this.selectedSchemaId)
        if (schemaName) {
          this.loadSchemaByName(schemaName)
            .catch((e) => {
              this.$emit('error', e)
            })
            .then(() => {
              this.loadingSchema = false
            })
        } else {
          this.loadingSchema = false
        }
      }
    }
  },
  methods: {
    updateMetadata(metadata, isValid) {
      this.metadata = { ...this.metadata, ...metadata }
      this.isValid = isValid
    },
    loadProduct() {
      return Masterdata.getProduct(this.productId).then((resp) => { this.product = resp.data })
    },
    loadMetadata() {
      return Core.getProductMetadata(this.productId).then((resp) => { this.metadata = resp.data })
    },
    loadSchemas() {
      return Core.listProductMetadataSchemas({ offset: 0, max: 10000 }).then((resp) => { this.schemas = resp.data.schema })
    },
    loadSchemaByName(name) {
      return Core.getProductMetadataSchema(name).then((resp) => { this.schema = resp.data })
    },
    findSchemaName(schemaId) {
      const schema = this.schemas.find((s) => s.id === schemaId)
      return schema ? schema.name : null
    },
    removeProductMetadata() {
      delete this.product.metadataSchemaId
      const servceCalls = []
      servceCalls.push(Masterdata.updateProduct(this.productId, this.product))
      servceCalls.push(Core.saveProductMetadata(this.productId, {}))
      return Promise.all(servceCalls)
    },
    updateProductMetadata(metadata) {
      const servceCalls = []
      if (this.selectedSchemaId !== this.product.metadataSchemaId) {
        this.product.metadataSchemaId = this.selectedSchemaId
        servceCalls.push(Masterdata.updateProduct(this.productId, this.product))
      }
      servceCalls.push(Core.saveProductMetadata(this.productId, metadata))
      return Promise.all(servceCalls)
    },

    doSave() {
      // clear / remove
      if (this.selectedSchemaId === null && this.product.metadataSchemaId) {
        this.$confirm({ text: 'This will remove previously stored metadata. Continue?' })
          .then((conf) => {
            if (conf) {
              return this.removeProductMetadata()
            }
          })
      }
      // update
      if (this.metadata) {
        const { metadata } = this
        this.loadingSave = true
        return this.updateProductMetadata(metadata)
      }
      // no update neccesary - rejected remove or invalid values in the editor
      return Promise.resolve(0)
    },

    save() {
      this.saving = true
      this.doSave()
        .then((updated) => {
          if (updated) {
            miniToastr.success('Product metadata updated successfully')
            this.$router.push({ name: 'product' })
          }
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    initialState() {
      if (!this.product) {
        return true
      }
      return this.selectedSchemaId === null && !this.product.metadataSchemaId
    },
    productId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    MetadataEditor
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/product/ProductMetadata.vue